import { CSSProperties, useEffect } from 'react';
import { useLayoutDispatch } from '../../provider/LayoutProvider';
import { useGetDownloadAppModalHeight } from '../modal/useGetDownloadAppModalHeight';
import { useAppSelector } from '../store/useStore';

type useLayoutTypes = {
  fixedHeader?: JSX.Element;
  fixedHeaderHeight?: number;
  fixedFooter?: JSX.Element;
  fixedFooterHeight?: number;
  style?: CSSProperties | undefined;
};

export const useLayout = (props: useLayoutTypes) => {
  const dispatch = useLayoutDispatch();
  const globalTooltipStates = useAppSelector((state) => state.globalTooltip);
  const { fixedHeader, fixedHeaderHeight, fixedFooter, fixedFooterHeight, style } = props;

  const downloadAppModalHeight = useGetDownloadAppModalHeight();

  useEffect(() => {
    dispatch({
      type: 'SET_FIXED_HEADER',
      elem: fixedHeader!,
      fixedHeaderHeight: fixedHeaderHeight! + downloadAppModalHeight,
    });

    dispatch({ type: 'SET_FIXED_BOTTOM', elem: fixedFooter!, fixedFooterHeight });

    if (!style) {
      dispatch({ type: 'SET_STYLE_RESET' });
    } else
      dispatch({
        type: 'SET_STYLE',
        style: style!,
      });
  }, [
    dispatch,
    fixedHeader,
    fixedHeaderHeight,
    fixedFooter,
    fixedFooterHeight,
    style,
    globalTooltipStates.downloadAppTooltipHeight,
  ]);
};

export const useLayoutStyleReset = () => {
  const dispatch = useLayoutDispatch();

  dispatch({ type: 'SET_STYLE_RESET' });
};
